<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'username')">
              <a-select
                v-model='queryParam.sysUserId'
                @change='userNameListonChange'
              >
                <a-select-option v-for='item in userNameList' :key='item.id'>
                  {{ item.userName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span='6'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'curdate')" :labelCol='{span: 6}'
                         :wrapperCol='{span: 14, offset: 1}'>
              <a-range-picker
                v-model='queryParam.orderGenerationDate'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter='12'>
          <a-col :span='6'>
                    <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
                      <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
                      <a-button type='primary' @click='searchReset' icon='reload'
                                style='margin-left: 8px'>{{ $t('reset')
                        }}</a-button>

                    </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
        <!--        <template slot='action' slot-scope='text, record'>-->
        <!--         -->
        <!--        </template>-->
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>

    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getUserOperationFlowInfo, findAllUserInfo } from '@/webpublicapi/customer'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.'
}
export default {
  name: 'AllApprovalTask',
  components: {
    Dict,
    DictSelect
  },
  data() {
    return {
      userNameList: [],
      paramsVal: {},
      I18N_KEY,
      visible: false,
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      // 查询条件
      queryParam: {
        'sysUserId': '',
        'orderGenerationDate': []
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '排序',
          align: 'left',
          dataIndex: 'sortid'
        },
        // {
        //   title: 'id',
        //   align: 'left',
        //   dataIndex: 'id',
        //   // sorter: (a, b) => this.sort(a, b, 'id'),
        //   // defaultSortOrder: 'ascend' // 默认升序排序
        // },
        {
          title: '系统用户名称',
          align: 'left',
          dataIndex: 'sysUserName'
        },
        {
          title: '登录ip',
          align: 'left',
          dataIndex: 'ipAddress'
        },
        {
          title: '登录时间',
          align: 'left',
          dataIndex: 'loginTime'
        }
        // {
        //   title: this.$t('action'),
        //   dataIndex: 'action',
        //   align: 'center',
        //   width: 370,
        //   scopedSlots: { customRender: 'action' }
        // }
      ]
    }
  },
  created() {
    this.loadData()
    findAllUserInfo().then(res => {
      console.log('findAllUserInfores', res)
      this.userNameList = res.data || []
    })
  },
  methods: {
    userNameListonChange(val) {
      console.log('改变啦！！！', val)
    },
    sort(a, b, key) {
      // console.log('a', a);
      // console.log('b', b);
      return a[key] - b[key]
    },
    searchQuery() {
      this.loadData()
    },
    loadData() {
      // 加载数据 若传入参数1则加载第一页的内容

      var params = this.getQueryParams()// 查询条件
      console.log('params烦死了！！！！！！！！！！！', params)

      if (params == null) {

      } else {
        this.loading = true

        getUserOperationFlowInfo(Object.assign({}, params)).then((res) => {
          if (res.code === 1000) {
            console.log('getUserOperationFlowInfores------->', res)
            this.dataSource = res.data.rows
            this.dataSource.forEach((item, index) => {
              item.sortid = index + 1
            })
            console.log(' this.dataSource-------》》》》', this.dataSource)

            this.total = res.data.total
            console.log('total', this.total)
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        }).catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
      }
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { orderGenerationDate } = this.queryParam
      console.log('orderGenerationDate', orderGenerationDate)
      if (orderGenerationDate.length) { //不能都选
        this.paramsVal = {
          ...this.queryParam,
          loginStartDate: orderGenerationDate && this.transformTime(orderGenerationDate[0]),
          loginEndDate: orderGenerationDate && this.transformTime(orderGenerationDate[1])
        }
      } else {
        console.log('时间没筛选')
        this.paramsVal = {
          ...this.queryParam
        }
      }
      // 分页参数
      this.paramsVal.pageNum = this.form.pageNum
      this.paramsVal.pageSize = this.form.pageSize
      delete this.paramsVal.orderGenerationDate
      return filterObj(this.paramsVal)
    },

    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.sysUserId = ''
      that.queryParam.orderGenerationDate = []//[moment().add('days'), moment().add('days', 0)]
      that.loadData(this.form.pageNum)
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
